<div class="thumbnail-container" [class.cursor-pointer]="thumbnailClickPath != ''">
  <div class="x-container" (click)="xClick()" *ngIf="!hideX"><span class="icon-close"></span></div>
  <img
    *ngIf="imageLoadSuccess"
    class="thumbnail"
    [src]="fullImageUrl"
    [attr.alt]="altText"
    [style.height]="height"
    [style.width]="width"
    [style.border-radius]="borderRadius"
    (click)="thumbnailClick()"
    (error)="onImgError($event)"
  />
  <!-- Match image box dimensions so empty/failed loads don't collapse layout (e.g. cart). -->
  <div
    class="thumbnail-placeholder align-items-center bg-light d-flex justify-content-center flex-column"
    *ngIf="!imageLoadSuccess"
    [style.height]="height"
    [style.width]="width"
    [style.border-radius]="borderRadius"
    rt="thumbnail-placeholder"
  >
    <i class="icon-camera fs-20 mb-1"></i>
    <div class="text-center font-weight-light thumbnail-placeholder-label">No photo</div>
  </div>
</div>
